import BaseModel from './BaseModel'

export default class LeadSource extends BaseModel {
  // ... LeadSource-specific methods or overrides ...
}
